/* eslint-disable */
self.onmessage = (event) => {
  const {expiresIn, updateTime} = event.data;

  const dataStorageTime = (new Date().getTime() - new Date(updateTime).getTime()) / 1000;

  if (dataStorageTime < expiresIn) {
    setTimeout(() => {
      self.postMessage('update');
    }, (expiresIn - dataStorageTime) * 1000);
  } else {
    self.postMessage('update');
  }
};
